<div [innerHtml]="props.template" [class]="props.class ? props.class : ''"></div>
